import { ApolloClient, gql, NormalizedCacheObject, useQuery } from "@apollo/client";
import { Mutation, Query } from "../types/generated/graphql";

export const useGetMyYouTubeProfiles = (client: ApolloClient<NormalizedCacheObject>) => {
  type T = Pick<Query, 'getMyYouTubeProfiles'>;
  const ret = useQuery<T>(QUERY_GET_MY_YOUTUBE_PROFILES, { 
    client, 
    variables: {},
    fetchPolicy: "network-only", // Always fetch from the server
  });

  return ret;
}

const QUERY_GET_MY_YOUTUBE_PROFILES = gql`
  query fct {
    getMyYouTubeProfiles {
      id
      name
      thumbnails {
        url
        height
        width
      }
      youtubeSignedOut
      youtubeSignedOutAt
      youtubeSignedOutReason
      youtubeSessionValid
      youtubeSessionLastCheckedAt
      youtubeSessionInvalidReason
      desktopLastSeenAt
      activeWorkers {
        deviceId
        name
        type
        lastSeenAt
        isActive
      }
      lastTaskAt
    }
  }
`;
